import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../../global-config'
import { orderQuestionSelfServiceAccessorGetSubOrderDetailTrackingUrl } from '../../../../order-question'
import { urlResolverGetOrderQuestionsTrackingPage } from '../../../../url-handling'
import { useContactPageLastOrderContext } from '../ContactPageLastOrderContext'

import { type ContactPageSelfServiceShortcutProps } from './ContactPageSelfServiceShortcutProps'

export const ContactPageSelfServiceShortcutSubOrderTrackingCta: FC<
  ContactPageSelfServiceShortcutProps
> = ({ availability }) => {
  const config = useGlobalConfigContext()

  const { activeSubOrder, firstSubOrder, lastOrder } =
    useContactPageLastOrderContext()

  const subOrder = activeSubOrder ?? firstSubOrder

  if (!subOrder?.subOrderId || !lastOrder?.orderMasterData?.orderNumber) {
    return null
  }

  if (availability === 'disabled') {
    return (
      <Button color="secondary" disabled size="small">
        <FormattedMessage id="account.lastOrder.trackingAvailableSoon.label" />
      </Button>
    )
  }

  return (
    <Button<'a'>
      color="secondary"
      data-qa-id="qa-id-tracking"
      href={
        orderQuestionSelfServiceAccessorGetSubOrderDetailTrackingUrl(
          config,
          subOrder,
        ) ??
        urlResolverGetOrderQuestionsTrackingPage(
          config,
          lastOrder.orderMasterData.orderNumber,
          subOrder.subOrderId,
        )
      }
      size="small"
      slots={{ root: 'a' }}
    >
      <FormattedMessage id="account.orders.trackDelivery" />
    </Button>
  )
}
